module.exports = __webpack_public_path__ + "img/pic_4.04a6735f.png";